'use client';

import { Switch as SwitchUI } from '@headlessui/react';
import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline';

interface ISwitchProps {
  /**
   * Whether the switch is checked or not.
   */
  isChecked?: boolean;
  /**
   * Whether the switch is disabled or not.
   */
  isDisabled?: boolean;
  /**
   * Handles the change event of the switch.
   */
  onChange?: (checked: boolean) => void;
}

/**
 * -----------------------------------------------------------------------------
 * A toggle button that can be used to enable or disable something.
 */
export function Switch({ isChecked, isDisabled, onChange }: ISwitchProps) {
  return (
    <SwitchUI
      checked={isChecked}
      className="
        pointer-cursor group relative inline-flex h-9 w-16 min-w-10
        flex-shrink-0 items-center rounded-full bg-green-900/40
        transition data-[checked]:bg-green-800 max-md:h-7 max-md:w-12
      "
      disabled={isDisabled}
      onChange={onChange}
    >
      <span
        className="
          z-20 size-6 translate-x-1 rounded-full bg-white transition group-data-[checked]:translate-x-8
          max-md:size-5 max-md:group-data-[checked]:translate-x-6
          rtl:-translate-x-1
          rtl:group-data-[checked]:-translate-x-8
          rtl:max-md:group-data-[checked]:-translate-x-6
        "
      />
      <span className="absolute z-10 flex h-full w-full items-center text-black">
        <div className="flex w-full grow justify-center">
          <CheckIcon className="w-4 text-white" />
        </div>
        <div className="flex w-full grow justify-center">
          <XMarkIcon className="w-4 text-white" />
        </div>
      </span>
    </SwitchUI>
  );
}
